<template>
  <div
    class="card"
    @click="$emit('clicked', $event)"
    :class="Array.from(styleClass)"
    :style="mostLeft()"
  >
    <button class="close-btn" @click="$emit('closed', $event)">
      &times;
    </button>
    <div class="sm:-mt-4">
      <div v-html="noteContent"></div>
      <Book
        v-if="metadata && metadata.type && metadata.type === 'book'"
        :metadata="metadata"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Book from "@/components/Book.vue";
import hljs from "highlight.js";

@Options({
  data() {
    return {
      styleClass: new Set(),
      isHandlingScroll: false,
      index: 0
    };
  },
  props: {
    noteContent: String,
    metadata: Object
  },
  components: {
    Book
  },
  created() {
    const cardContainer = document.getElementsByClassName("home-container")[0];
    if (cardContainer) {
      cardContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  mounted() {
    setTimeout(() => {
      this.index = Number(this.$el.id);
      const els = this.$el.getElementsByTagName("a");
      els.forEach(el => {
        el.addEventListener("mouseenter", e => this.$emit("overlink", e));
        el.addEventListener("mouseleave", e => this.$emit("leavelink", e));
      });
      [...els]
        .filter(l => l.matches("a[href*='://']"))
        .forEach(l => l.classList.add("ext-link"));
      this.highlightCode();
    }, 20);
  },
  updated() {
    setTimeout(() => {
      this.index = Number(this.$el.id);
    }, 20);
  },
  unmounted() {
    const cardContainer = document.getElementsByClassName("home")[0];
    if (cardContainer) {
      cardContainer.removeEventListener("scroll", this.handleScroll);
    }
    const els = this.$el.getElementsByTagName("a");
    els.forEach(el => {
      el.removeEventListener("mouseenter", e => this.$emit("overlink", e));
      el.removeEventListener("mouseleave", e => this.$emit("leavelink", e));
    });
  },
  methods: {
    highlightCode() {
      hljs.configure({
        tabReplace: "  ",
        languages: ["javascript", "python", "ruby", "swift", "c"]
      });
      setTimeout(() => {
        this.$el.getElementsByTagName("code").forEach(block => {
          hljs.highlightBlock(block);
        });
      }, 600);
    },
    mostLeft() {
      return {
        left: `${this.index * 42}px`
      };
    },
    handleScroll() {
      if (this.isHandlingScroll) return;
      this.isHandlingScroll = true;
      setTimeout(() => {
        this.addShadowIfNeeded();
        this.transformIfNeeded();
        this.isHandlingScroll = false;
      }, 50);
    },
    addShadowIfNeeded() {
      if (this.index === 0) {
        return;
      } else {
        const myEl = document.getElementById(this.index.toString());
        const leftEl = document.getElementById((this.index - 1).toString());
        if (myEl && leftEl) {
          const shadowClass = "shadow-overlay";
          if (
            myEl.getBoundingClientRect().left <
            leftEl.getBoundingClientRect().right
          ) {
            if (!this.styleClass.has(shadowClass)) {
              this.styleClass.add(shadowClass);
              leftEl.classList.add("covered");
            }
          } else {
            if (this.styleClass.has(shadowClass)) {
              this.styleClass.delete(shadowClass);
              leftEl.classList.remove("covered");
            }
          }
        }
      }
    },
    transformIfNeeded() {
      const myEl = document.getElementById(this.index.toString());
      const rightEl = document.getElementById((this.index + 1).toString());
      const tinyViewClass = "tiny-view";

      if (myEl && rightEl) {
        if (
          rightEl.getBoundingClientRect().left -
            myEl.getBoundingClientRect().left <=
          80
        ) {
          if (!this.styleClass.has(tinyViewClass)) {
            this.styleClass.add(tinyViewClass);
            (myEl.getElementsByClassName("note-title") as HTMLCollectionOf<
              HTMLElement
            >)[0].style.left = `${this.index * 42 + 8}px`;
          }
        } else {
          if (this.styleClass.has(tinyViewClass))
            this.styleClass.delete(tinyViewClass);
        }
      } else {
        if (this.styleClass.has(tinyViewClass))
          this.styleClass.delete(tinyViewClass);
      }
    }
  },
  emits: ["clicked", "closed", "overlink", "leavelink"]
})
export default class Card extends Vue {
  noteContent!: string;
  metadata?: object;
}
</script>
